module.exports = __webpack_public_path__ + "media/images/flags/4x3/gmb-3c66b459630baeba35597ff3bebd92aa.svg";